import React, {Component} from 'react';
import Loader from '../../Loader/Loader';
import styles from './styles/KingstonConnect.scss';
import axios from 'axios';
import BackToDashboard from './BackToDashboard';
import ManageProfilePassword from './ManageProfilePassword';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";

export default class ManageProfile extends Component {

  constructor(props) {
    super(props);
    this.state = {
      saving: false,
      employerData: {
        _id: undefined,
        email: undefined,
        first_name: undefined,
        last_name: undefined,
        company: undefined,
        address: undefined,
        website: undefined,
      }
    }
  }

  componentDidMount() {
    let id = sessionStorage.getItem('employer');
    axios
      .post("/api/kingstonconnect/getemployer/", {"_id": id})
      .then(res => {
        this.setState({
          employerData: {
            _id: res.data._id,
            email: res.data.email,
            first_name: res.data.first_name,
            last_name: res.data.last_name,
            company: res.data.company,
            address: res.data.address,
            website: res.data.website
          },
          saved_recently: undefined,
          error_saving: undefined
        });
        return Promise.resolve(1);
      })
      .catch(e => console.log(e));
  }

  updateEmployer = (e) => {
    e.preventDefault();
    this.setState({ saving: true })
    axios
      .post("/api/kingstonconnect/updateemployer/", this.state.employerData)
      .then(res => {
        this.setState({
          error_saving: false,
          saved_recently: true,
          saving: false
        })
        return Promise.resolve(1);
      })
      .catch(e => {
        this.setState({
          error_saving: true,
          saved_recently: false,
          saving: false
        })
        console.log(e)
      });
  }

  handleChange = (e) => {
    this.setState({
      error_saving: false,
      saved_recently: false,
      employerData: {
        ...this.state.employerData,
        [e.target.name]: e.target.value
      }
    })
  }

  render() {
    if (!this.state.employerData) {
      return <Loader />
    } else {

      return (
        <div className={styles.page}>
          <h1> Edit <strong>Kingston<span style={{color: '#007D99'}}>Connect</span></strong> Account </h1>
          <BackToDashboard />
          <form onSubmit={this.updateEmployer}>
              <div className="form-group col-6 offset-3">
                <label>Email</label>
                <input onChange={this.handleChange} name='email'  className="form-control" defaultValue={this.state.employerData.email} disabled/>

                <label>Password</label>
                <div>
                  <small className="text-muted">You must re-enter your password to save changes.</small>
                </div>
                <input required onChange={this.handleChange} name='password' type="password" className="form-control"/>

                <div className="row">
                  <div className="form-group col-6">
                    <label>First Name</label>
                    <input onChange={this.handleChange} name='first_name'  className="form-control" defaultValue={this.state.employerData.first_name}/>
                  </div>
                  <div className="form-group col-6">
                    <label>Last Name</label>
                    <input onChange={this.handleChange} name='last_name'  className="form-control" defaultValue={this.state.employerData.last_name}/>
                  </div>
                </div>

                <label>Company Name</label>
                <input onChange={this.handleChange} name='company'  className="form-control" defaultValue={this.state.employerData.company}/>

                <label>Address</label>
                <input onChange={this.handleChange} name='address' type="text"  className="form-control" defaultValue={this.state.employerData.address}/>

                <label>Website</label>
                <input onChange={this.handleChange} name='website' type="text"  className="form-control" defaultValue={this.state.employerData.website}/>
                <br/>

                {this.state.saved_recently &&
                  <div className="alert alert-success" role="alert">
                  <strong>Saved!</strong> Your recent changes have been saved.
                  </div>
                }
                {this.state.error_saving &&
                  <div className="alert alert-danger" role="alert">
                  <strong>Uh oh!</strong> Password may be incorrect, try submitting again.
                  </div>
                }
              </div>
              <button className="btn btn-primary">
                {"Update Profile "}
                {this.state.saving &&
                  <FontAwesomeIcon spin
                  icon={faSpinner}
                  />
                }
              </button>
            </form>
            <br/>
            <ManageProfilePassword _id={this.state.employerData._id} />
        </div>
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/KingstonConnect/ManageProfile.js